import React from "react";
import logo from "../../assets/images/craiyon_110920_image.png";

export default function LoginSlide({ progress }) {
  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{ height: "100vh" }}
    >
      <div
        className="card shadow p-2 d-flex align-items-center  "
        style={{ backgroundColor: "rgba(255, 255, 255, 0.5)" }}
      >
        <img
          src={logo}
          alt="Loading..."
          style={{
            width: "140px",
          }}
        />
        <div className="progress w-100 mt-1">
          <div
            style={{
              height: "100%",
              width: `${progress}%`,
              backgroundColor: "#000080",

              transition: "width 0.1s linear",
            }}
          ></div>
        </div>
      </div>
    </div>
  );
}
